/* PopoverContent CSS Module */

.container {
  /* Animation CSS variables (set via inline style) */
  --vapor-popover-mount-duration: 200ms;
  --vapor-popover-unmount-duration: 125ms;
  --vapor-popover-shadow: var(--shadows-12dp);
  --vapor-popover-distance: 4px;
  --vapor-popover-scale: 0.97;

  background: var(--colors-components-popover-background);
  border-color: var(--colors-components-popover-border);
  border-radius: var(--radii-8);
  border-style: solid;
  border-width: 1px;
  box-shadow: var(--vapor-popover-shadow);
  display: flex;
  flex-direction: column;
  outline: none;
  position: relative;

  /* Animation base styles */
  list-style: none;
  opacity: 1;
  transition-duration: var(--vapor-popover-mount-duration);
  transition-property: opacity, transform;
  transition-timing-function: var(--transitions-eases-primary);
  will-change: transform, opacity;

  /* Pseudo-element for hit area expansion */
  &::after {
    bottom: -4px;
    content: '';
    left: -4px;
    position: absolute;
    right: -4px;
    top: -4px;
    z-index: -1;
  }

  &:where([data-positioner]) {
    position: fixed;
  }

  &:where([data-reference-hidden]) {
    opacity: 0;
    pointer-events: none;
  }

  &:where([data-hide-overflow]) {
    overflow: hidden;
  }

  /* Entering/Exiting states */
  &:where([data-entering]),
  &:where([data-exiting]) {
    opacity: 0;
    transform: scale(var(--vapor-popover-scale)) translateY(0) translateX(0);
  }

  &:where(:not([data-position])) {
    opacity: 0;
  }

  &:where([data-exiting]) {
    transition-duration: var(--vapor-popover-unmount-duration);
  }

  /* Bottom placements */
  &:where([data-position*='bottom'][data-entering]),
  &:where([data-position*='bottom'][data-exiting]) {
    transform: scale(var(--vapor-popover-scale)) translateY(calc(-1 * var(--vapor-popover-distance))) translateX(0);
  }

  &:where([data-position='bottom']) {
    transform-origin: 50% 0;
  }

  &:where([data-position='bottom-start']) {
    transform-origin: 0 0;
  }

  &:where([data-position='bottom-end']) {
    transform-origin: 100% 0;
  }

  /* Top placements */
  &:where([data-position*='top'][data-entering]),
  &:where([data-position*='top'][data-exiting]) {
    transform: scale(var(--vapor-popover-scale)) translateY(var(--vapor-popover-distance)) translateX(0);
  }

  &:where([data-position='top']) {
    transform-origin: 50% 100%;
  }

  &:where([data-position='top-start']) {
    transform-origin: 0 100%;
  }

  &:where([data-position='top-end']) {
    transform-origin: 100% 100%;
  }

  /* Right placements */
  &:where([data-position*='right'][data-entering]),
  &:where([data-position*='right'][data-exiting]) {
    transform: scale(var(--vapor-popover-scale)) translateY(0) translateX(calc(-1 * var(--vapor-popover-distance)));
  }

  &:where([data-position='right']) {
    transform-origin: 0 50%;
  }

  &:where([data-position='right-start']) {
    transform-origin: 0 0;
  }

  &:where([data-position='right-end']) {
    transform-origin: 0 100%;
  }

  /* Left placements */
  &:where([data-position*='left'][data-entering]),
  &:where([data-position*='left'][data-exiting]) {
    transform: scale(var(--vapor-popover-scale)) translateX(var(--vapor-popover-distance)) translateY(0);
  }

  &:where([data-position='left']) {
    transform-origin: 100% 50%;
  }

  &:where([data-position='left-start']) {
    transform-origin: 100% 0;
  }

  &:where([data-position='left-end']) {
    transform-origin: 100% 100%;
  }
}
